import GeoLocationService from './GeoLocationService';
import DMAStorageService from './DMAStorageService';

export default class DMAService {
    constructor() {
        this.GeoLocation = new GeoLocationService();
        this.DMAStorage = new DMAStorageService();
        this.location = null;
        this.currentLocation = this.DMAStorage.getCurrentLocation();
        let [dma,stationId] = this.DMAStorage.getDMAStationIdStringOnNow();
        this.dma=dma;
        this.stationId = stationId;
    }

    updateLocation(){
        let loc = {
            lat: this.location.coords.latitude,
            lon: this.location.coords.longitude
        };
        this.DMAStorage.setCurrentLocation(loc);
    }

    async getDMA() {
        try {
            this.location = await this.GeoLocation.fetchLocation();

            if (this.currentLocation == null) {
                this.updateLocation();
                this.dma = null;
            } else {
                if (this.currentLocation.lat != this.location.coords.latitude || this.currentLocation.lon != this.location.coords.longitude) {
                    this.updateLocation();
                    this.dma = null;
                }
            }
    
            if (this.dma === null) {
                let response  = await fetch(CBS.Registry.region.prefix +'/live-tv/dma/' +this.location.coords.latitude +'/' +this.location.coords.longitude)
                const resultData = await response.json();

                if(resultData.result.dmas){
                    this.parseResult(resultData);
                }
            }
    
            return {
                dma:this.dma,
                stationId:this.stationId
            };
        } catch (error) {
            console.log("ERROR", error)
        }
    }

    parseResult(resultData){
        let paramDmas = '';
        let paramStationIds = '';
        let storageDma = [];
        resultData.result.dmas.forEach((dma) => {
            paramDmas += paramDmas == '' ? dma.dma : ',' + dma.dma;
            paramStationIds += paramStationIds == '' ? dma.stationId : ',' + dma.stationId;
            storageDma.push({
                dma: dma.dma,
                stationId: dma.stationId,
                stationSlug: dma.callSignId.toLowerCase()
            });
        });

        this.DMAStorage.setStorageDMA(storageDma);

        this.dma = paramDmas;
        this.stationId = paramStationIds;
    }
}